import type { IBuilderSection, IBuilderField } from '@/@types/insuranceBuilder';

const OLD_TO_NEW_FIELD_TYPE: Record<string, IBuilderField['fieldType']> = {
  text: 'text',
  number: 'number',
  date: 'date',
  file: 'file',
  boolean: 'checkbox',
  select: 'select',
  claims: 'text',
  provider: 'text',
};

export interface IBuildSeedSectionsArgs {
  source: string;
  matchedPredefined?: {
    defaultFields: Array<{ label: string; fieldType: string; options?: string[] }>;
  } | null;
  copySource?: { sections: IBuilderSection[] } | null;
}

export function buildSeedSections(args: IBuildSeedSectionsArgs): IBuilderSection[] {
  if (args.source === 'predefined' && args.matchedPredefined) {
    const fields: IBuilderField[] = args.matchedPredefined.defaultFields.map((f, idx) => ({
      fieldKey: crypto.randomUUID(),
      label: f.label,
      fieldType: OLD_TO_NEW_FIELD_TYPE[f.fieldType] ?? 'text',
      required: false,
      sortOrder: idx,
      customOptions: f.options,
    }));
    return [
      { sectionKey: crypto.randomUUID(), title: 'Details', columns: 2, sortOrder: 0, fields },
    ];
  }
  if (args.source === 'copy' && args.copySource) {
    return args.copySource.sections.map(sec => ({
      ...sec,
      sectionKey: crypto.randomUUID(),
      fields: sec.fields.map(f => ({ ...f, fieldKey: crypto.randomUUID() })),
    }));
  }
  return [];
}
